import { gql } from "@apollo/client";
import { ReportTemplate } from "../../../../Definitions";
import { REPORT_TEMPLATE_FRAGMENT } from "./getReportsTemplateCall";

export const CREATE_REPORT_TEMPLATE = gql`
  mutation CreateTemplate($domain: String!, $name: String!, $dataLevel: Int!, $filterParameter: [[FilterInput!]!]!, $shouldArchive: Boolean!) {
    report {
      createTemplate(domain: $domain, name: $name, data_level: $dataLevel, filter: $filterParameter, should_archive: $shouldArchive) {
        ...ReportTemplateFields
      }
    }
  }
  ${REPORT_TEMPLATE_FRAGMENT}
`

export interface CreateReportTemplateResponse {
  report: {
    createTemplate: ReportTemplate[]
  }
}